import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OrgMember {
  id: string;
  name: string;
  email: string | null;
  role: string;
}

export function useOrgMembersQuery(orgId: string | undefined, enabled = true) {
  return useQuery<OrgMember[]>({
    queryKey: ["org-members-with-profiles", orgId],
    enabled: !!orgId && enabled,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("organization_members")
        .select("user_id, role")
        .eq("org_id", orgId!);
      if (error) throw error;

      const userIds = [...new Set((data || []).map((m: any) => m.user_id as string))].filter(Boolean);
      if (!userIds.length) return [];

      const { data: profiles, error: profilesError } = await supabase
        .from("profiles")
        .select("id, name, email")
        .in("id", userIds);
      if (profilesError) throw profilesError;

      const profileMap = new Map((profiles || []).map((p: any) => [p.id, p]));
      return (data || []).map((m: any) => {
        const profile = profileMap.get(m.user_id);
        return {
          id: m.user_id as string,
          name: (profile?.name || profile?.email || "Usuário") as string,
          email: (profile?.email ?? null) as string | null,
          role: m.role as string,
        };
      });
    },
  });
}
